export default __webpack_public_path__ + "static/media/zip.f4f202b2.svg";